import React from 'react'
import SrollToTop from '../components/ScrollToTop'
import SignIn from '../components/Signin'

const SigninPage = () => {
  return (
    <div>
      <SrollToTop />
      <SignIn />
    </div>
  )
}

export default SigninPage
